































































import { Component, Mixins } from 'vue-property-decorator'
import { State } from 'vuex-class'
import axios from 'axios'
import store, { Mutations } from '../../store'
import { IOnboardingPayload } from 'serverless-firestore'
import IconsMixin from '@/mixins/IconsMixin.vue'
import AuthMixin from '@/mixins/AuthMixin.vue'
import PhoneNumber from '@/components/PhoneNumber.vue'

@Component({
  components: { PhoneNumber }
})
export default class CreateAdminLogin extends Mixins(IconsMixin, AuthMixin) {
  @State('onboarding') public onboarding!: IOnboardingPayload

  public valid = false
  public saving = false
  public error = ''

  public get name() {
    return this.onboarding && this.onboarding.admin
      ? this.onboarding.admin.name
      : ''
  }
  public set name(name: string) {
    store.commit(Mutations.UPDATE_ONBOARDING, {
      onboarding: {
        ...this.onboarding,
        admin: {
          ...this.onboarding.admin,
          name
        }
      }
    })
  }

  public get phoneNumber() {
    return this.onboarding && this.onboarding.admin
      ? this.onboarding.admin.phoneNumber
      : ''
  }
  public set phoneNumber(phoneNumber: string) {
    store.commit(Mutations.UPDATE_ONBOARDING, {
      onboarding: {
        ...this.onboarding,
        admin: {
          ...this.onboarding.admin,
          phoneNumber
        }
      }
    })
  }

  public async submit() {
    this.error = ''
    this.saving = true
      if(
        this.onboarding.token
        && this.onboarding.token
        && typeof this.onboarding.token === 'string'
      ) {
        try {
          if (this.onboarding.restaurants.length > this.onboarding.restaurantLimit) {
            this.error = `You have exceeded the maximum number of restaurants in your subscription plan. Please go back and reduce your restaurant to to ${this.onboarding.restaurantLimit} or less`
            this.saving = false
            return
          }

          const res = await axios.post('/api/onboarding/jwt', { onboarding_token: this.onboarding.token })
          await axios.post('/api/onboarding', this.onboarding)
          this.$router.push({ name: 'verify-admin'})
        } catch (err) {
          let message: string = err.response.data.message;
          message = message.split(' ')
            .map(s => s.charAt(0).toUpperCase() + s.slice(1))
            .join(' ')
          this.error = message || 'An Unknown Error Has Occured';
          this.saving = false

          return
        }
      } else {
        this.error = 'Invalid Onboarding Token'
      }

    this.saving = false
  }
}
